// Utility function to determine button state and text
export const getButtonState = (inputValues, tabIndex, tokens, maxClicked, rangeStatus) => {
    const hasValidInput = Object.values(inputValues || {}).some((value) => value && value.trim() !== '' && parseFloat(value) > 0);
    const text = tabIndex === 0 || tabIndex === undefined ? 'Deposit' : 'Withdraw';
    // Disable deposit button if range status is out of range
    if ((tabIndex === 0 || tabIndex === undefined) && rangeStatus === 'outOfRange') {
        return { disabled: true, text: 'Deposit' };
    }
    if (!hasValidInput) {
        return { disabled: true, text };
    }
    if (!maxClicked || tabIndex === 0 || tabIndex === undefined) {
        for (const [tokenSymbol, inputValue] of Object.entries(inputValues || {})) {
            if (inputValue && inputValue.trim() !== '') {
                const token = tokens === null || tokens === void 0 ? void 0 : tokens.find((t) => t.symbol === tokenSymbol);
                const inputAmount = parseFloat(inputValue);
                if (isNaN(inputAmount) || !isFinite(inputAmount)) {
                    continue;
                }
                const balance = parseFloat((token === null || token === void 0 ? void 0 : token.walletBalance) || '0');
                if (inputAmount > balance) {
                    const text = tabIndex === 0 || tabIndex === undefined
                        ? 'Amount exceeds wallet balance'
                        : 'Amount exceeds vault balance';
                    return { disabled: true, text };
                }
            }
        }
    }
    // Button is enabled - return appropriate action text
    return { disabled: false, text };
};
